// Listen for the htmx:afterOnLoad event to initialize drag-and-drop
document.body.addEventListener("htmx:afterOnLoad", function (event) {
    const target = event.target;
    if (target.id === "repeaterContainer") {
        const newItems = target.querySelectorAll(
            ".repeaterItem:not([data-drag-init])",
        );
        newItems.forEach((newItem) => {
            makeDraggable(newItem);
            newItem.setAttribute("data-drag-init", "true");
        });
    }
});

let restrictToParent = null;

function isDragWithinRestrictedParent(target) {
    const parentContainer = target.closest(".repeaterCont");
    return parentContainer === restrictToParent;
}

export function restrictDragToParent(newItem) {
    restrictToParent = newItem.closest(".repeaterCont");
}

export function makeDraggable(newItem) {
    newItem.draggable = true;
    newItem.addEventListener("dragstart", handleDragStart);
    newItem.addEventListener("dragover", handleDragOver);
    newItem.addEventListener("drop", handleDrop);
    newItem.addEventListener("dragend", handleDragEnd);
    newItem.addEventListener("dragleave", handleDragLeave);
}

// TODO - This is not firing correctly
function resetStyles() {
    const repeaterItems = document.querySelectorAll(".repeaterItem");
    repeaterItems.forEach((item) => {
        item.style.opacity = "1";
        item.style.boxShadow = "";
        item.style.borderRadius = "";
    });
}

function findRepeaterItem(element) {
    while (element && !element.classList.contains("repeaterItem")) {
        element = element.parentElement;
    }
    return element;
}

function handleDragStart(event) {
    event.dataTransfer.setData("text/plain", event.target.id);
    event.dataTransfer.effectAllowed = "move";
    event.target.style.opacity = "0.25";
}

function handleDragOver(event) {
    event.preventDefault();
    const target = event.target;

    const repeaterItem = findRepeaterItem(target);

    if (repeaterItem) {
        repeaterItem.style.boxShadow = "0 0 0 2px black";
        repeaterItem.style.borderRadius = "6px";
    }

    target.addEventListener("dragleave", handleDragLeave);
}

function handleDragLeave(event) {
    const target = event.target;

    // Find the parent repeaterItem
    const repeaterItem = findRepeaterItem(target);

    if (repeaterItem) {
        repeaterItem.style.boxShadow = "";
        repeaterItem.style.borderRadius = "";
    }
}

function handleDrop(event) {
    event.preventDefault();
    const data = event.dataTransfer.getData("text/plain");
    const target = event.target;

    resetStyles();

    if (!isDragWithinRestrictedParent(target)) {
        return;
    }

    // Find the closest parent with class 'repeaterItem'
    const repeaterItem = target.closest(".repeaterItem");

    if (repeaterItem) {
        const parent = repeaterItem.parentElement;
        const draggedItem = document.getElementById(data);

        if (draggedItem && parent) {
            const boundingRect = repeaterItem.getBoundingClientRect();
            const mouseY = event.clientY;

            // Define the expanded threshold
            const threshold = boundingRect.height / 0.5;

            // Determine the insert position based on the cursor position
            let insertPosition;

            if (mouseY < boundingRect.top + threshold) {
                // Above the drop target
                insertPosition = Array.from(parent.children).indexOf(
                    repeaterItem,
                );
            } else if (mouseY > boundingRect.bottom - threshold) {
                // Below the drop target
                insertPosition =
                    Array.from(parent.children).indexOf(repeaterItem) + 1;
            } else {
                // In the middle of the drop target
                insertPosition = Array.from(parent.children).indexOf(
                    repeaterItem,
                );
            }

            // Insert the dragged item at the calculated position
            parent.insertBefore(draggedItem, parent.children[insertPosition]);
        }
    }
}

function handleDragEnd(event) {
    resetStyles();
}
